import React from 'react';
import LetterText from './LetterText';

function LetterPage({ onShowArchives, letter }) {
  if (!letter) return <div>No letter found.</div>;
  const { letterContent } = letter;
  return (
    <div className="page">
      <div className="envelope-flap" />
      <div className="letter">
        <div className="letter-header">
          <h1 className="title">Alex & Reegan</h1>
          <div className="stamp">💌</div>
        </div>
        <div className="divider" />
        <div className="letter-body">
          {letterContent.image && (
            <img
              src={letterContent.image}
              alt="A special memory of Alex and Reegan"
              style={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: '12px',
                marginBottom: '1rem',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
              }}
            />
          )}
          <p className="greeting">{letterContent.greeting}</p>
          <LetterText text={letterContent.text} photos={letterContent.photos} />
          <p className="closing">{letterContent.closing}</p>
          <p className="signature">{letterContent.signature}</p>
          <button onClick={onShowArchives} style={{ marginTop: '1.5em', padding: '0.6em 1.5em', borderRadius: '8px', background: '#ffe0e9', color: '#c94f7c', border: 'none', fontWeight: 600, cursor: 'pointer', boxShadow: '0 1px 4px #ffb6b933' }}>
            View Archives
          </button>
        </div>
        <div className="wax-seal">♥</div>
      </div>
    </div>
  );
}

export default LetterPage;
